import { render, staticRenderFns } from "./TennisCourt.vue?vue&type=template&id=efc01e68&"
import script from "./TennisCourt.vue?vue&type=script&lang=ts&"
export * from "./TennisCourt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports